import { ComponentProps } from "react";
import * as S from "./styles";

interface IInfoProps extends ComponentProps<"div"> {
  required?: boolean;
  text: string;
}

export const Info = ({ required, text, ...props }: IInfoProps) => {
  return (
    <S.InfoWrapper {...props}>
      {required ? <span>*</span> : null}
      {text}
    </S.InfoWrapper>
  );
};
